// import _ from 'lodash'
import request from '@/utils/request'

const prefix = '/django_rest/employee/management'

export default {
  getEmployeeList (params) {
    return request.get(`${prefix}/`, { params })
  },
  updateCompanyRegisterStatus (params) {
    return request.post('/referral/company-employee/check-register/', params)
  },
  updateEmployeeStatus (params) {
    return request.post(`${prefix}/`, params)
  },
  updateEmailSuffix (params) {
    return request.post(`${prefix}/email-suffix/`, params)
  },
  getUploadEmployeeResult (params) {
    return request.get('/referral/upload-employee-status/', { params })
  },
  uploadEmployee (file) {
    const fileData = new FormData()
    fileData.append('batch_upload_file', file)
    return request.post('/referral/upload-employee-status/', fileData)
  }
}
